import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import SaudeService from '../../../../../../services/saude-auth';
import { Link, Navigate, useParams } from 'react-router-dom';



const FormStatus = () => {
    const [situacao, setSituacao] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchInscricao(id) {
        const response = await SaudeService.saudeEdit(id);
        setSituacao(response.data["situacao"]);
    }

    useEffect(() => {
        fetchInscricao(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const ouvidoria = await SaudeService.editar(id, {
                situacao: situacao
            });        
            setSucesso(true)
            setError(false)
            alert("Inscrição validada com sucesso!")
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col>
                                    <Form.Group className="mb-3" controlId="situacao">
                                        <FloatingLabel
                                            label="Situação"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="situacao"
                                                name="situacao"
                                                onChange={e => setSituacao(e.target.value)}
                                            >
                                                <option value={situacao}>{situacao}</option>
                                                <option value="Inscrito">Inscrito</option>
                                                <option value="Pendente">Pendente</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/restrito/saude/conferencia'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Inscrição atualizada com sucesso!</Alert>
                <Navigate to={'/restrito/saude/conferencia'} />
            </Fragment>
        )
    }
}

export default FormStatus